var styles = {"wrap":"HeroCard-module_wrap__gdsAk","image":"HeroCard-module_image__3GThG","content":"HeroCard-module_content__2nRc3"};

export { styles as default };
//# sourceMappingURL=HeroCard.module.css.js.map
